export const SETTINGS_DARK_OVERLAY_PRESET_STYLE_TEXT = `
.kg-settings-root[data-kg-settings-theme-mode="dark"],
body:has(.kg-settings-root[data-kg-settings-theme-mode="dark"]) .kg-settings-modal-backdrop,
body:has(.kg-settings-root[data-kg-settings-theme-mode="dark"]) .kg-settings-modal-frame-host > .ds-modal,
body:has(.kg-settings-root[data-kg-settings-theme-mode="dark"]) .kg-settings-modal-backdrop .ds-alert,
body:has(.kg-settings-root[data-kg-settings-theme-mode="dark"]) .kg-settings-modal-backdrop .ds-toast {
  --kg-settings-overlay-scrim: var(--ds-overlay-scrim, color-mix(in srgb, var(--ds-text, currentColor) 82%, transparent));
  --kg-settings-overlay-surface: linear-gradient(180deg, color-mix(in srgb, var(--ds-surface-base, Canvas) 98%, transparent), color-mix(in srgb, var(--ds-surface-raised, Canvas) 98%, transparent));
  --kg-settings-overlay-border: var(--ds-border-subtle, currentColor);
  --kg-settings-overlay-shadow: var(--ds-shadow-overlay, none);
  --kg-settings-overlay-text: var(--ds-text, CanvasText);
  --kg-settings-overlay-text-2: var(--ds-text-subtle, var(--ds-text-muted, GrayText));
  --kg-settings-overlay-focus: var(--ds-focus-ring, currentColor);
}
`;
